<template>
	<div class="banner">
		<div class="banner-contain">
			<div class='riwen'>
				<p class='biaoti center'>GARDEN</p>
			</div>
			<div class='getpassheight'>
				<p class='getpass center'>{{i18n.forgetpwd_0}}</p>
			</div>
			<el-form ref="form" :rules="rules" :model="form">
				<div class='plassemail'>
					<el-form-item prop="email" :rules="[
					{ required: true, message: $t('forgetpwd.forgetpwd_1'), trigger: 'blur' },
					{ type: 'email', message:  $t('forgetpwd.forgetpwd_11'), trigger: ['blur', 'change'] }
					]">
						<el-input v-model="form.email" style='width:100%' auto-complete="off" :placeholder="$t('forgetpwd.forgetpwd_1')" clearable></el-input>
					</el-form-item>
				</div>
				<div class="plassver">
					<el-form-item prop="ver">
						<el-input class="inp" v-model="form.ver" auto-complete="off" :placeholder="$t('forgetpwd.forgetpwd_2')" style='width:60%'
						 clearable></el-input>
						<el-button class="verbutton" :type="primary" :disabled="disabled" v-model="form.forgetpwd_5" :loading="load" @click="handleClickone()"
						 style='width:35%'>{{i18n.forgetpwd_5}}</el-button>
					</el-form-item>
				</div>
				<el-form-item prop="newpwd" class="plasspwdtwo sure">
					<el-input type="password" ref="form.newpwd" :placeholder="$t('forgetpwd.forgetpwd_3')" v-model="form.newpwd"
					 auto-complete="new-password" clearable></el-input>
				</el-form-item>
				<el-form-item prop="renewpwd" class="plasspwdtwo sure">
					<el-input type="password" ref="form.renewpwd" :placeholder="$t('forgetpwd.forgetpwd_23')" v-model="form.renewpwd"
					 auto-complete="new-password" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<div class='sure Determine'>
						<el-button type="primary" class="submit" @click='submitForm'>{{i18n.forgetpwd_7}}</el-button>
					</div>
				</el-form-item>
			</el-form>
			<el-footer>
				<div class="center think">
					<span class=' el-link--inner el-link el-link--primary ' style="color:#878889;margin-right:10px;">{{i18n.forgetpwd_8}}</span>
					<el-link type="primary" @click='login'>{{i18n.forgetpwd_9}}</el-link>
				</div>
			</el-footer>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'forgetPwd',
		data() {
			var validatePass = (rule, value, callback) => {
				if (!value) {
					callback(new Error(this.$t('forgetpwd.forgetpwd_3')));
				} else if (value.toString().length < 6 || value.toString().length > 18) {
					callback(new Error(this.$t('forgetpwd.forgetpwd_4')))
				} else {
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error(this.$t('forgetpwd.forgetpwd_23')));
				} else if (value.toString().length < 6 || value.toString().length > 18) {
					callback(new Error(this.$t('forgetpwd.forgetpwd_4')))
				} else if (value !== this.form.newpwd) {
					callback(new Error(this.$t('forgetpwd.forgetpwd_6')));
				} else {
					callback();
				}
			};
			return {
				form: {
					pass: '',
					checkPass: '',
					ver: "",
					email: "",
					newpwd: '',
					renewpwd: '',
				},
				// 校验规则
				rules: {
					newpwd: [{
						required: true,
						validator: validatePass,
						trigger: ['blur', 'change']
					}],
					renewpwd: [{
						required: true,
						validator: validatePass2,
						trigger: ['blur', 'change']
					}],
					email: [{
							required: true, //是否必填
							message: this.$t('forgetpwd.forgetpwd_17'), //规则
							trigger: 'blur' //何事件触发
						},
						{
							min: 6,
							max: 18,
							message: this.$t('forgetpwd.forgetpwd_4')
						}
					],
					ver: [{
							required: true, //是否必填
							message: this.$t('forgetpwd.forgetpwd_10'), //规则
							trigger: 'blur' //何事件触发
						},
						{
							min: 6,
							max: 6,
							message: this.$t('forgetpwd.forgetpwd_25'),
						}
					],
				},
				emailma: "",
				verma: "",
				load: false,
				response: "",
				primary: "primary",
				verspan: this.$t('forgetpwd.forgetpwd_10'),
				email: '',
				verbutton: "",
				disabled: false,
				verm: "",
				timer: 120,
				auth_timer: "",
				forgetpwd_5: this.$t('forgetpwd.forgetpwd_5'),
				forgetpwd_5s: "s",
			}
		},
		computed: {
			// 国际化
			i18n() {
				return this.$t('forgetpwd')
			}
		},
		mounted() {
		    // 在页面加载时获取登录信息
			this.getCookie();
		},
		methods: {
			//读取cookie
			getCookie: function() {
			  if (document.cookie.length > 0) {
				var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
				for (var i = 0; i < arr.length; i++) {
				  var arr2 = arr[i].split("="); //再次切割
				  //判断查找相对应的值
				  if (arr2[0] == "userName") {
					this.form.email = arr2[1]; //保存到保存数据的地方
				  }
				}
			  }
			},
			//点击获取验证码的按钮
			handleClickone: function() { 
				var reg = /^([A-Za-z0-9_\.-]+)@([\dA-Za-z\.-]+)\.([A-Za-z\.]{2,6})$/;

				if (reg.test(this.form.email)) {
					this.forgetpwd_5 = this.$t('forgetpwd.forgetpwd_26');
				}
				this.$refs.form.validateField("email");
				this.load = true;
				
				var postUrl = 'WCF/WEB/svcUAA.svc/getCode';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl, 
					//请求参数
					{
						sEmail: this.form.email,
						sFalg: 1, //0 注册 、1 修改密码
						sLanguage: '0'
					})
					.then((response) => { //这里使用了ES6的语法

					this.response = response.data.KKSTR;
					this.emailma = this.form.email;
					this.verma = response.data.KKSTR;
					
					if (this.response == "E") {
						this.forgetpwd_5 = this.$t('forgetpwd.forgetpwd_5');
						var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
						if (reg.test(this.form.email)) {
							this.$message({
								message: this.$t('forgetpwd.forgetpwd_20'),
								type: 'error',
							});
						} else if (response.data.KKSTR == "N") {
							this.forgetpwd_5 = this.$t('forgetpwd.forgetpwd_5');
							this.$message({
								message: this.$t('forgetpwd.forgetpwd_22'),
								type: 'error',
							});
						}
						this.load = false;
					} 
					else 
					{
						clearInterval(this.auth_timer);
						this.load = true;
						this.primary = "info";
						this.timer = 120;
						this.auth_timer = setInterval(() => {
							this.timer--;
							if (this.timer > 0) {
								this.load = false;
								this.disabled = "disabled";
								this.forgetpwd_5 = this.timer + "s";
							} 
							else if (this.timer == "1") {
								clearInterval(this.auth_timer);
								this.load = false;
								this.disabled = false;
								this.primary = "primary";
								this.timer = this.$t('forgetpwd.forgetpwd_13');
							} 
							else if (this.timer = this.$t('forgetpwd.forgetpwd_13')) 
							{
								this.disabled = false;
								clearInterval(this.auth_timer);
								this.verbutton = 'verbuttontwo';
								this.forgetpwd_5 = this.$t('forgetpwd.forgetpwd_13');
							}
						},
						1000);
					}
				}).
				catch((error) => {

				});
			},
			login: function() { //直接登录
				this.$router.push('/login');
			},
			submitForm: function() { //点击确认按钮触发事件
				this.$refs.form.validate((valid) => {
					if (valid) {} else {

						return false;
					}
				});
				releaseEvents();
				var reg = "/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/";
				if ((this.emailma != this.form.email || this.verma != this.form.ver) && this.form.email != "" && this.form.ver !=
					"" && this.form.ver.length == 6 && this.emailma != "" && this.verma != "") {
					this.$message({
						message: this.$t('forgetpwd.forgetpwd_24'),
						type: 'error',
					});
					return;
				}
				if (this.form.ver != this.response) {
					this.$message({
						message: this.$t('forgetpwd.forgetpwd_14'),
						//该邮箱未注册
						type: 'error',
					});
					return;
				} else if (this.form.ver == this.response && this.forgetpwd_5 == this.$t('forgetpwd.forgetpwd_13')) {
					this.$message({
						message: this.$t('forgetpwd.forgetpwd_21'),
						type: 'error',
					});
					return;
				} else if (this.form.ver != this.response) {
					this.$message({
						message: this.$t('forgetpwd.forgetpwd_14'),
						type: 'error',
					});
				}
				if (this.form.newpwd != this.form.renewpwd) {
					return;
				}
				
				if (this.form.email != "" && this.form.ver != "" && this.form.newpwd != "" && this.form.renewpwd != "" && this.form.newpwd == this.form.renewpwd && this.form.newpwd.length == 6 && this.form.renewpwd.length == 6) 
				{
					var postUrl = 'WCF/WEB/svcUAA.svc/forgetPassword';
					//网络请求接口
					this.$axios.post(
					//请求的url
					postUrl, 
					//请求参数
					{
						sEmail: this.form.email,
						sPassword: this.$md5(this.form.renewpwd),
						sLanguage: '0'
					})
					.then((response) => {
						if (response.data.KKSTR == "E") {
							var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
							if (reg.test(this.form.email)) {
								this.$message({
									message: this.$t('forgetpwd.forgetpwd_20'),
									type: 'error',
								});
								return;
							}
						} 
						else if (response.data.KKSTR == "N") {
							this.$message({
								message: this.$t('forgetpwd.forgetpwd_22'),
								//该邮箱未注册
								type: 'error',
							});
						} 
						else if (response.data.KKSTR == "Y") {
							this.$message({
								message: this.$t('forgetpwd.forgetpwd_19'),
								//该邮箱未注册
								type: 'success',
							});
							this.$router.push('/login');
						}
					}).
					catch((error) => {

					});
				}
			}
		}
	}
</script>
<style scope>
	body {
		font-size: 16px;
	}
	
	.riwen {
		height: 40px;
	}
	
	.biaoti {
		color: #1890FF;
		font-size: 32px;
		font-weight: bold;
		margin-top: 44px;
	}
	
	.getpassheight {
		/*找回密码高度*/
		height: 30px;
		margin-top: 5px;
		margin-bottom: 5px;
	}
	
	.border {
		border: 1px solid
	}
	
	.getpass {
		/*找回密码样式*/
		padding-top: 5px;
		font-size: 18px;
		color: #878889;
	}
	
	.plassemail {
		/*请输入邮箱*/
		width: 352px;
		margin: 0 auto;
		height: 52px;
		margin-top: 18px;
	}
	
	.plassver {
		/*请输入验证码*/
		width: 352px;
		margin: 0 auto;
		margin-top: 25px;
		height: 50px;
	}
	
	.think {
		/*想起来了*/
		height: 20px;
		margin-top: 15px;
	}
	
	.verbutton {
		/*验证码按钮样式*/
		height: 44px;
		width: 123px;
		margin-left: 10px;
	}
	
	.ver {
		/*验证验证码是不是空*/
		width: 219px;
		font-size: 12px;
		color: red;
	
		height: 32px;
	}
	
	.submit {
		/*确定按钮样式*/
		margin-top: 33px;
		font-size: 14px;
		height: 45px;
		width: 100%;
	}
	
	.plasspwdtwo {
		margin-top: 27px;
		height: 50px;
	}
	
	.center {
		/*定义文字居中*/
		text-align: center;
	}
	
	.sure {
		/*确定的div*/
		width: 352px;
		margin-left: auto;
		margin-right: auto;
	}
	
	.Determine {
		width: 352px;
		margin-left: auto;
		margin-right: auto;
		margin-top: -20px;
	}
	
	.thinkout {
		/*想起来了*/
		color: #101010;
	}
	
	.banner {
		/*最大的div*/
		position: relative;
		width: 100%;
		height: 100%;
		background-image: url(../assets/img/login-bg.jpg);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-attachment: fixed;
	}
	
	.banner-contain {
		/*内容层*/
		position: absolute;
		background: #F6F6F6;
		width: 452px;
		left: calc(50% - 226px);
		height: 558px;
		z-index: 6;
		/*将内容至于上层*/
		margin-top: 10%;
		border-radius: 10px
	}
	.el-input--small .el-input__inner {
		height: 44px;
	}

	el-link {
		font-size: 14px;
	}

	.el-link.el-link--default:hover {
		color: #101010;
		text-decoration: none;
	}

	.el-form-item__error {
		margin-top: 10px;
	}

	.el-button--info.is-disabled,
	.el-button--info.is-disabled:active,
	.el-button--info.is-disabled:focus,
	.el-button--info.is-disabled:hover {
		background-color: #c8c9cc;
		color: #666;
	}

	.el-button--info {
		background-color: #409EFF;
		border: #409EFF;
	}

	.el-button--info:hover {
		background-color: #a0cfff;
		border: #a0cfff;
	}
</style>
